// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"fe0578a7ced91e978885","524":"230f602dd8600c3f232f","810":"de1ee78d2e19dc07e2e0"}[chunkId] + ".css";
};